import { render, staticRenderFns } from "./JoinForm.vue?vue&type=template&id=08949de0&scoped=true&"
import script from "./JoinForm.vue?vue&type=script&lang=js&"
export * from "./JoinForm.vue?vue&type=script&lang=js&"
import style0 from "./JoinForm.vue?vue&type=style&index=0&id=08949de0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08949de0",
  null
  
)

export default component.exports